import React, { createContext, useContext, useState } from 'react';
import { api } from 'app';

const VirgoolsUIContext = createContext();

export function useVirgoolsUIContext() {
  return useContext(VirgoolsUIContext);
}

export function VirgoolsUIProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async query => {
    const q = query.slice(1);
    api
      .get(`/virgool-advertises?include=event,advertise&${q}`)
      .then(response => {
        setData(response);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const value = {
    fetchData,
    data,
    setData,
    isLoading,
    setIsLoading
  };

  return <VirgoolsUIContext.Provider value={value}>{children}</VirgoolsUIContext.Provider>;
}
